module.exports = __webpack_public_path__ + "img/podcast-fan.e7f0bb61.png";